export default "__VITE_ASSET__DS$v8t08__"